import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from '../store';

const selectPack = ({ pack }: RootState) => pack;

// Buying selectors

export const selectPackAuthorInfo = createSelector(
  selectPack, ({ buying: { author } }) => author,
);

export const selectPackCollectionInfo = createSelector(
  selectPack, ({ buying: { collection } }) => collection,
);

export const selectPackLoading = createSelector(
  selectPack, ({ isLoading }) => isLoading,
);

export const selectPackStatus = createSelector(
  selectPack, ({ buying: { status } }) => status,
);

export const selectIsBuyingEnd = createSelector(
  selectPack, ({ buying: { isBuyingEnd } }) => isBuyingEnd,
);

export const selectPurchaseStatus = createSelector(
  selectPack, ({ buying: { purchaseStatus } }) => purchaseStatus,
);

// Pack page selectors

export const selectActiveUserPack = createSelector(
  selectPack, ({ packPage: { allUserActivePacks } }) => allUserActivePacks,
);

// Pack open selectors

export const selectOpenPackLoading = createSelector(
  selectPack, ({ open: { isLoad } }) => isLoad,
);

export const selectErrorOpenPack = createSelector(
  selectPack, ({ open: { isError } }) => isError,
);

export const selectIsOpenPack = createSelector(
  selectPack, ({ open: { isOpen } }) => isOpen,
);

export const selectCardsToOpen = createSelector(
  selectPack, ({ open: { cardsToOpen } }) => cardsToOpen,
);

export const selectPackPageLoading = createSelector(
  selectPack, ({ packPage: { isLoading } }) => isLoading,
);

export const selectIsPackOpening = createSelector(
  selectPack, ({ isPackOpening }) => isPackOpening,
);

export const selectIsProfileUpdating = createSelector(
  selectPack, ({ isProfileUpdating }) => isProfileUpdating,
);

export const selectPackLeaderByCollectionId = (collectionId: string) => createSelector(
  selectPack, ({ packBattleMap }) => packBattleMap[collectionId],
);
